import { ModalProps, Modal } from 'antd';
import { breakpoints } from 'components';
import React from 'react';
import styled from 'styled-components';

interface VideoModalProps extends ModalProps {
  url: string;
  handleClose: () => void;
  title: string;
}

const VideoModal = ({ url, handleClose, title, ...rest }: VideoModalProps) => (
    <Modal
      data-cy="modal-popup"
      footer={null}
      onCancel={handleClose}
      title={title}
      width={breakpoints.md}
      {...rest}
    >
      <Container>
        <StyledIFrame
          src={url}
          allow="encrypted-media; picture-in-picture"
          allowFullScreen
        />
      </Container>
    </Modal>
  );

export default VideoModal;

const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
